import { setIn } from 'immutable';
import { HIDAction, HIDActionType } from '../_actions/HIDActions';
import HIDStore from '../_stores/HIDStore';

const HIDReducer = (store:HIDStore = new HIDStore(), action: HIDAction):HIDStore => {
	switch (action.type) {
		case HIDActionType.OnSpaceDown:
			return setIn(store, ['spaceDown'], true);
		
		case HIDActionType.OnSpaceUp:
			return setIn(store, ['spaceDown'], false);

		case HIDActionType.OnModDown:
			return setIn(store, ['modDown'], true);

		case HIDActionType.OnModUp:
			return setIn(store, ['modDown'], false);
		
		case HIDActionType.OnShiftDown:
			return setIn(store, ['shiftDown'], true);
		
		case HIDActionType.OnShiftUp:
			return setIn(store, ['shiftDown'], false);

		case HIDActionType.OnAltDown:
			return setIn(store, ['altDown'], true);

		case HIDActionType.OnAltUp:
			return setIn(store, ['altDown'], false);
	}
	return store;
}

export default HIDReducer



